<template>
  <div class="container">
    <div v-if="commentsExist">
      <ul>
        <li v-for="comment in comments.data" v-bind:key="comment._id">
          <CommentCard v-bind:comment="comment"></CommentCard>
        </li>
      </ul>
    </div>
    <div v-else>
      <h1 class="title">
        No comments to show
      </h1>
    </div>
  </div>
</template>

<script>
import CommentCard from "./CommentCard.vue";

export default {
  name: "CommentList",
  components: {
    CommentCard
  },
  props: ["comments"],
  data: function() {
    return {
      comment: {
        username: "vuvvi",
        time: "12:00",
        comment: "this site is going to be awesome"
      }
    };
  },
  methods: {
    sosad() {
      return '';
    }
  },
  computed: {
    commentsExist() {
      return "null" != this.comments;
    }
  }
};
</script>
